import styled from "@emotion/styled";
import { Text } from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledText = styled(Text)`
  color: ${({ theme }) => theme.palette.grey[500]};
  text-align: center;
`;
